import { render, staticRenderFns } from "./index.mpx?vue&type=template&id=b7e6f0bc&isPage"
import script from "./index.mpx?vue&type=script&lang=js&isPage"
export * from "./index.mpx?vue&type=script&lang=js&isPage"
import style0 from "./index.mpx?vue&type=style&index=0&id=b7e6f0bc&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_e4d6bfcc%22%7D&isPage"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports